import type { ResourceLanguage } from "i18next";

import { Tk } from "../translation-key";
import { pluralForSlavic, tk } from "../utils";

const RESOURCES = {
  translation: {
    EN: "англ",
    UK: "укр",
    DE: "нем",
    SK: "слов",
    RU: "рус",
    ENGLISH: "английский",
    UKRAINIAN: "украинский",
    GERMAN: "немецкий",
    SLOVAK: "словацкий",
    RUSSIAN: "русский",
    ORDER_ACCEPTANCE: "прием заказов",
    INTRODUCTION: "вступление",
    CALCULATOR: "калькулятор",
    PROFESSIONAL_RELOCATION_SERVICES_IN_SWITZERLAND:
      "профессиональные услуги по переезду в Швейцарии",
    RELIABLE_LOADERS_EXPERIENCED_DRIVERS_AND_THE_BEST_PRICE_ON_THE_MARKET:
      "надежные грузчики, опытные водители и лучшая цена на рынке",
    CALCULATE_THE_COST: "рассчитайте стоимость",
    SUPPORT: "поддержка",
    RELIABLE_SERVICE: "надежный сервис",
    WHY_CUSTOMERS_CHOOSE_US: "почему клиенты выбирают нас",
    FAVORABLE_PRICES: "выгодные цены",
    THE_BEST_PRICES_ON_THE_MARKET_WITHOUT_HIDDEN_FEES: "лучшие цены на рынке без скрытых платежей",
    FAST_CAR_DELIVERY: "быстрая подача авто",
    TRANSPORT_WILL_ARRIVE_WITHIN_30_60_MINUTES: "транспорт прибудет в течение 30-60 минут",
    EXPERIENCED_LOADERS: "опытные грузчики",
    QUALIFIED_EMPLOYEES_WITH_EXTENSIVE_WORK_EXPERIENCE:
      "квалифицированные сотрудники с большим опытом работы",
    GUARANTEE_OF_PRESERVATION: "гарантия сохранения",
    YOUR_BELONGINGS_ARE_SAFE_THROUGHOUT_THE_MOVE:
      "ваши вещи в безопасности на протяжении всего переезда",
    OUR_SERVICES: "наши услуги",
    WE_OFFER_A_FULL_RANGE_OF_SERVICES_FOR_MOVING_APARTMENTS_OFFICES_AND_INDUSTRIAL_FACILITIES:
      "предлагаем полный спектр услуг для квартирного, офисного и промышленного переезда",
    APARTMENT_MOVING: "квартирный переезд",
    OFFICE_RELOCATION: "офисный переезд",
    INDUSTRIAL_RELOCATION: "промышленный переезд",
    MORE_DETAILS: "подробнее",
    MOVING_COST: "стоимость переезда",
    FLEXIBLE_PRICING_SYSTEM_FOR_DIFFERENT_ORDERS:
      "гибкая система ценообразования для разных заказов",
    MINIMUM: "минимальный",
    FROM_PRICE: "от {{price}}",
    CARGO_GAZELLE: "грузовая газель",
    TRUCK: "грузовик",
    T: "т",
    NUMBER_OF_LOADERS: "количество грузчиков",
    POPULAR: "популярный",
    PRICE_FOR_A_1_ROOM_APARTMENT: "цена за 1-комнатную квартиру",
    PRICE_FOR_A_HOUSE_WITH_AN_AREA_OF_UP_TO_100_M: "цена за здание площадью до 100 м²",
    PRICE_FOR_AN_OFFICE_WITH_AN_AREA_OF_UP_TO_50_M: "цена за офис площадью до 50 м²",
    ORDER: "заказ",
    [tk(Tk.ORDER, { plural: "one" })]: "заказ",
    ...pluralForSlavic(Tk.ORDER, "заказы"),
    [tk(Tk.ORDER, { partOfSpeech: "verb" })]: "заказать",
    COST_CALCULATOR: "калькулятор стоимости",
    CALCULATE_THE_COST_OF_YOUR_MOVE: "рассчитайте стоимость вашего переезда",
    SELECT_SERVICES: "выберите услуги",
    TRANSPORTATION: "транспортировка",
    PACKING_THINGS: "упаковка вещей",
    LOADING_UNLOADING: "загрузка/разгрузка",
    VEHICLE: "транспортное средство",
    YOUR_ORDER: "ваш заказ",
    TOTAL: "всего",
    OUR_CUSTOMERS_REVIEWS: "отзывы наших клиентов",
    HOW_DO_WE_WORK: "как мы работаем",
    PREPARATION: "подготовка",
    MOVING: "переезд",
    YOU_LEAVE_A_REQUEST_ON_THE_WEBSITE_OR_CALL_OUR_MANAGER_WILL_CONTACT_YOU_WITHIN_15_MINUTES:
      "вы оставляете заявку на сайте или звоните по телефону. Наш менеджер свяжется с вами в течение 15 минут",
    WE_CALCULATE_THE_COST_AGREE_ON_A_TIME_BRING_PACKING_MATERIALS_AND_PREPARE_THE_TEAM:
      "мы рассчитываем стоимость, согласовываем время, привозим упаковочные материалы и готовим команду",
    OUR_SPECIALISTS_ARRIVE_AT_THE_APPOINTED_TIME_CAREFULLY_PACK_LOAD_AND_TRANSPORT_YOUR_BELONGINGS:
      "наши специалисты прибывают в назначенное время, тщательно упаковывают, загружают и транспортируют ваши вещи",
    CONTACT_US: "свяжитесь с нами",
    ADDRESS: "адрес",
    [tk(Tk.ADDRESS, { plural: "one" })]: "адрес",
    ...pluralForSlavic(Tk.ADDRESS, "адреса"),
    PHONE: "телефон",
    [tk(Tk.PHONE, { plural: "one" })]: "телефон",
    ...pluralForSlavic(Tk.PHONE, "телефоны"),
    EMAIL: "электронная почта",
    [tk(Tk.EMAIL, { case_: "genitive" })]: "электронной почты",
    WORK_SCHEDULE: "график работы",
    SOCIAL_NETWORKS: "социальные сети",
    WRITE_TO_US: "напишите нам",
    REQUEST_SUBJECT: "тема запроса",
    I_D_LIKE_TO_ORDER: "я хочу сделать заказ",
    QUESTIONS_ABOUT_SERVICES: "вопросы по услугам",
    OTHER: "другое",
    MESSAGE: "сообщение",
    SEND: "отправить",
    CONVENIENT_FAST_RELIABLE: "удобно, быстро, надежно",
    ALL_RIGHTS_RESERVED: "все права защищены",
    THERE_WAS_AN_ERROR_LOADING_DATA: "при загрузке данных произошла ошибка",
    TRY_AGAIN: "попробовать еще раз",
    ORDER_A_MOVE: "заказать переезд",
    CONTACT_PERSON: "контактное лицо",
    FULL_NAME: "полное имя",
    CITY: "город",
    FLOOR: "этаж",
    IS_THERE_AN_ELEVATOR: "есть ли лифт",
    DESCRIPTION_OF_CARGO: "описание груза",
    FROM_WHERE: "откуда",
    TO: "куда",
    SEND_AN_APPLICATION: "отправить заявку",
    DOES_NOT_MATCH_FORMAT: "не соответствует формату {{format}}",
    NOT_ENOUGH_CHARACTERS_AT_LEAST_N_REQUIRED:
      "недостаточно символов, нужно по крайней мере {{count}}",
    WHAT_IS_INCLUDED_IN_THE_SERVICE: "что входит в услугу",
    NO_INFORMATION_PROVIDED_AT_THIS_TIME: "информация не предоставлена",
    MUST_BE_A_NUMBER: "должно быть числом",
    MUST_BE_GREATER_THAN_N: "должно быть больше {{count}}",
    MUST_BE_AT_LEAST_N: "должно быть по меньшей мере {{count}}",
    FIELD_CANNOT_BE_EMPTY: "поле не может быть пустым",
    FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS: "поле должно содержать не менее {{count}} символа",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "one" })]:
      "поле должно содержать не менее {{count}} символа",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "few" })]:
      "поле должно содержать не менее {{count}} символов",
    [tk(Tk.FIELD_MUST_CONTAIN_AT_LEAST_N_CHARACTERS, { plural: "many" })]:
      "поле должно содержать не менее {{count}} символов",
    FIELD_MUST_MATCH_FORMAT: "поле должно соответствовать формату {{format}}",
    FIELD_MUST_CONTAIN_A_NUMBER: "поле должно содержать число",
    VALUE_MUST_BE_GREATER_THAN_N: "значение должно быть больше {{count}}",
    MINIMUM_VALUE_IS_N: "минимальное значение – {{count}}",
    FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER: "поле должно содержать не более {{count}} символа",
    [tk(Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER, { plural: "one" })]:
      "поле должно содержать не более {{count}} символа",
    ...pluralForSlavic(
      Tk.FIELD_MUST_CONTAIN_NO_MORE_THAN_N_CHARACTER,
      "поле должно содержать не более {{count}} символов",
    ),
    VALUE_MUST_BE_LESS_THAN_N: "значение должно быть меньше {{count}}",
    MAXIMUM_VALUE_IS_N: "максимальное значение — {{count}}",
    PICK_A_DATE: "выберите дату",
    HOW_DID_YOU_HEAR_ABOUT_US: "как вы о нас узнали",
    PLEASE_TELL_US_HOW_YOU_FOUND_OUT_ABOUT_US: "пожалуйста, расскажите нам, как вы узнали о нас",
    WEB_SEARCH: "веб-поиск",
    FRIEND_RECOMMENDATIONS: "рекомендации друзей",
    SOCIAL_MEDIA: "социальные сети",
    ADVERTISING: "реклама",
    GENDER: "пол",
    MALE: "мужской",
    FEMALE: "женский",
    UNDETERMINED: "неопределенный",
    POSTAL_CODE: "почтовый индекс",
    BUILDING_TYPE: "тип здания",
    PRIVATE_HOUSE: "частный дом",
    APARTMENT: "квартира",
    OFFICE: "офис",
    AREA: "площадь",
    M: "м",
    NUMBER_OF_ROOMS: "количество комнат",
    IS_THERE_AN_ATTIC: "есть ли чердак",
    IS_THERE_A_BASEMENT: "есть ли подвал",
    PLANNED_MOVING_DATE: "запланированная дата переезда",
    SELECTED_SERVICES: "выбранные услуги",
    MENU: "меню",
    DASHBOARD: "дашборд",
    DOCUMENTATION: "документация",
    ADMINISTRATOR: "администратор",
    A: "а",
    MY_PROFILE: "мой профиль",
    ORDER_MANAGEMENT: "управление заказами",
    SERVICE_MANAGEMENT: "управление услугами",
    USER_MANAGEMENT: "управление пользователями",
    NEW: "новый",
    [tk(Tk.NEW, { plural: "one" })]: "новый",
    ...pluralForSlavic(Tk.NEW, "новые"),
    ...pluralForSlavic(Tk.NEW, "нового", { plural: "one", case_: "genitive" }),
    ...pluralForSlavic(Tk.NEW, "новых", { case_: "genitive" }),
    COMPLETED: "выполнен",
    [tk(Tk.COMPLETED, { plural: "one" })]: "выполнен",
    ...pluralForSlavic(Tk.COMPLETED, "выполнены"),
    ...pluralForSlavic(Tk.COMPLETED, "выполненного", { plural: "one", case_: "genitive" }),
    ...pluralForSlavic(Tk.COMPLETED, "выполненных", { case_: "genitive" }),
    REVENUE: "доход",
    SINCE_YESTERDAY: "со вчерашнего дня",
    LATEST_ORDERS: "последние заказы",
    SHOW_ALL: "показать все",
    ID: "ид",
    CLIENT: "клиент",
    DATE: "дата",
    SUM: "сумма",
    STATUS: "статус",
    IN_PROGRESS: "в процессе",
    ASSIGNED: "назначен",
    CANCELLED: "отменен",
    ANNUAL_REVENUE: "годовой доход",
    ADD_ORDER: "добавить заказ",
    FILTER: "фильтр",
    WITH_ELEVATOR: "с лифтом",
    WITHOUT_ELEVATOR: "без лифта",
    EDIT: "редактировать",
    DELETE: "удалить",
    YES: "да",
    NO: "нет",
    ADD_A_SERVICE: "добавить услугу",
    NAME: "имя",
    [tk(Tk.NAME, { animateness: "inanimate" })]: "название",
    CATEGORY: "категория",
    [tk(Tk.CATEGORY, { plural: "one" })]: "категория",
    ...pluralForSlavic(Tk.CATEGORY, "категории"),
    [tk(Tk.CATEGORY, { case_: "genitive" })]: "категории",
    [tk(Tk.CATEGORY, { case_: "accusative" })]: "категорию",
    PRICE: "цена",
    ACTIVE: "активный",
    [tk(Tk.ACTIVE, { gender: "feminine" })]: "активная",
    INACTIVE: "неактивный",
    [tk(Tk.INACTIVE, { gender: "feminine" })]: "неактивная",
    ADD_USER: "добавить пользователя",
    EMPLOYEE: "работник",
    USER: "пользователь",
    [tk(Tk.USER, { plural: "one" })]: "пользователь",
    ...pluralForSlavic(Tk.USER, "пользователи"),
    [tk(Tk.USER, { case_: "accusative" })]: "пользователя",
    ROLE: "роль",
    [tk(Tk.ROLE, { plural: "one" })]: "роль",
    ...pluralForSlavic(Tk.ROLE, "роли"),
    VIEW: "просмотреть",
    ORDER_INFORMATION: "информация о заказе",
    CREATION_DATE: "дата создания",
    TOTAL_COST: "общая стоимость",
    QUANTITY: "количество",
    INFORMATION_NOT_PROVIDED: "информация не предоставлена",
    CHANGE_STATUS: "изменить статус",
    ACTIONS: "действия",
    PRINT: "печать",
    STATUS_SUCCESSFULLY_CHANGED: "статус успешно изменен",
    FAILED_TO_CHANGE_STATUS: "не удалось изменить статус",
    THIS_ORDER_WAS_NOT_FOUND: "этот заказ не найден",
    SERVICE_CATEGORY_MANAGEMENT: "управление категориями услуг",
    DESCRIPTION: "описание",
    ADD_CATEGORY: "добавить категорию",
    THIS_ACTION_CANNOT_BE_UNDONE: "это действие нельзя отменить",
    NO_RECORDS_FOUND_IN_THE_DATABASE: "в базе данных не найдено никаких записей",
    NUMBER: "номер",
    SIZE: "размер",
    CREATE: "создать",
    LANGUAGE: "язык",
    SELECT_THE_LANGUAGE_IN_WHICH_YOU_WANT_TO_PROVIDE_DATA_FOR_FILLING_IN:
      "выберите язык, на котором вы хотите предоставить данные для заполнения",
    SAVE: "сохранить",
    RESET: "сбросить",
    IMAGE: "изображение",
    ADD: "добавить",
    HYPERLINK: "гиперссылка",
    CHANGES_SAVED_SUCCESSFULLY: "изменения успешно сохранены",
    FAILED_TO_SAVE_CHANGES: "не удалось сохранить изменения",
    SERVICE: "услуга",
    [tk(Tk.SERVICE, { plural: "one" })]: "услуга",
    ...pluralForSlavic(Tk.SERVICE, "услуги"),
    [tk(Tk.SERVICE, { case_: "genitive" })]: "услуги",
    [tk(Tk.SERVICE, { case_: "accusative" })]: "услугу",
    THE_DATE_MUST_NOT_BE_IN_THE_PAST: "дата не должна быть в прошлом",
    ORDER_REQUEST: "запрос на заказ",
    PASSWORD: "пароль",
    ADMINISTRATIVE_PANEL: "административная панель",
    FORGOT_YOUR_PASSWORD: "забыли пароль",
    REMEMBER_ME: "запомнить меня",
    SIGN_IN: "войти",
    FAILED_TO_LOG_IN: "не удалось войти",
    AN_UNEXPECTED_ERROR_OCCURRED_PLEASE_TRY_AGAIN_LATER:
      "произошла неожиданная ошибка, попробуйте еще раз позже",
    INCORRECT_EMAIL_ADDRESS_AND_OR_PASSWORD: "неверный адрес электронной почты и/или пароль",
    SIGN_OUT: "выйти",
    FIRST_NAME: "имя",
    LAST_NAME: "фамилия",
    THIS_EMAIL_ADDRESS_IS_ALREADY_IN_USE_BY_ANOTHER_USER:
      "этот адрес электронной почты уже используется другим пользователем",
    SUBJECT: "тема",
    BODY: "тело",
    SENDING_AN_EMAIL: "отправка электронного письма",
    EMAIL_SENT_SUCCESSFULLY: "электронное письмо успешно отправлено",
    SOME_OF_THE_SELECTED_ROLES_DO_NOT_EXIST: "некоторые из выбранных ролей не существуют",
    INQUIRY: "запрос",
    [tk(Tk.INQUIRY, { plural: "one" })]: "запрос",
    ...pluralForSlavic(Tk.INQUIRY, "запросы"),
    [tk(Tk.INQUIRY, { case_: "genitive" })]: "запроса",
    [tk(Tk.INQUIRY, { case_: "accusative" })]: "запрос",
    FAILED_TO_LOAD_YOUR_DATA: "не удалось загрузить ваши данные",
    ACCESS_TO_THE_PAGE_IS_DENIED: "доступ к странице запрещен",
    ONLY_ADMINISTRATORS_HAVE_ACCESS_TO_THIS_PAGE:
      "только администраторы имеют доступ к этой странице",
    ONLY_ADMINISTRATORS_AND_EMPLOYEES_HAVE_ACCESS_TO_THIS_PAGE:
      "только администраторы и сотрудники имеют доступ к этой странице",
    YOU_ARE_ALREADY_LOGGED_IN: "вы уже вошли в систему",
    AUTHENTICATION_SESSION_EXPIRED: "сеанс аутентификации закончился",
    ORDERED_SERVICES: "заказанные услуги",
    [tk(Tk.ORDERED_SERVICES, { case_: "genitive" })]: "заказанных услуг",
    THE_DATE_MUST_NOT_BE_EARLIER_THAN_THE_CURRENT_MOMENT:
      "дата не должна быть раньше текущего момента",
    YOU_HAVE_NOT_SELECTED_ANY_SERVICES: "вы не выбрали никакой услуги",
    VALUE_MUST_MATCH_PHONE_NUMBER_FORMAT: "значение должно соответствовать формату номера телефона",
    "ENTER_THE_VALUE_IN_INTERNATIONAL_PHONE_NUMBER_FORMAT_I_E_...":
      "введите значение в международном формате номера телефона, то есть +, код страны и сам номер телефона (без пробелов), например: +41791234567",
    ACCOUNT_LOGIN: "вход в аккаунт",
    "PROFESSIONAL_ORGANIZATION_OF_MOVING_TO_FROM_...":
      "профессиональная организация переезда в/из квартиры, офиса или частного дома в Швейцарии. Быстро, безопасно и без проблем. Спланируйте свой переезд вместе с нами!",
    "MOVING_IN_SWITZERLAND_APARTMENT_MOVING_OFFICE...":
      "переезд в Швейцарии, переезд квартиры, переезд офиса, переезд частного дома, переезд квартиры, перевозка мебели в Швейцарии, услуги по переезду",
    INQUIRY_MANAGEMENT: "управление запросами",
    RESOLVED: "решено",
    ADMINISTRATOR_COMMENT: "комментарий администратора",
    RESOLVE: "решить",
    INQUIRY_RESOLUTION: "решение запроса",
    REVIEW_MANAGEMENT: "управление обзорами",
    RATING: "рейтинг",
    PROS: "плюсы",
    CONS: "минусы",
    TEXT: "текст",
    REVIEW: "отзыв",
    [tk(Tk.REVIEW, { plural: "one" })]: "отзыв",
    ...pluralForSlavic(Tk.REVIEW, "отзывы"),
    [tk(Tk.REVIEW, { case_: "genitive" })]: "отзыва",
    [tk(Tk.REVIEW, { case_: "accusative" })]: "отзыв",
    FAILED_TO_OPEN_PRINT_WINDOW: "не удалось открыть окно печати",
    NEW_ORDER: "новый заказ",
    NEW_INQUIRY: "новый запрос",
    NEW_REVIEW: "новый отзыв",
    SOMETHING_HAPPENED: "что-то произошло",
    MARK_AS_READ: "пометить как прочитанное",
    FAILED_TO_MARK_NOTIFICATION_AS_READ: "не удалось пометить уведомление как прочитанное",
    MARK_ALL_AS_READ: "отметить все как прочитанные",
    FAILED_TO_MARK_ALL_NOTIFICATIONS_AS_READ: "не удалось отметить все уведомления как прочитанные",
    NOTIFICATION: "оповещение",
    ORDER_CREATION: "создание заказа",
    SERVICE_CREATION: "создание услуги",
    CATEGORY_CREATION: "создание категории",
    USER_CREATION: "создание пользователя",
    ORDER_CREATED: "заказ создан",
    SERVICE_CREATED: "услуга создана",
    CATEGORY_CREATED: "категория создана",
    USER_CREATED: "пользователь создан",
    INQUIRY_CREATED: "запрос создан",
    REVIEW_CREATED: "отзыв создан",
    ORDER_REQUEST_CREATED: "запрос на заказ создан",
    FAILED_TO_CREATE_ORDER: "не удалось создать заказ",
    FAILED_TO_CREATE_SERVICE: "не удалось создать услугу",
    FAILED_TO_CREATE_CATEGORY: "не удалось создать категорию",
    FAILED_TO_CREATE_USER: "не удалось создать пользователя",
    FAILED_TO_CREATE_INQUIRY: "не удалось создать запрос",
    FAILED_TO_CREATE_REVIEW: "не удалось создать отзыв",
    FAILED_TO_CREATE_ORDER_REQUEST: "не удалось создать запрос на заказ",
    ORDER_DELETED: "заказ удален",
    SERVICE_DELETED: "услуга удалена",
    CATEGORY_DELETED: "категория удалена",
    USER_DELETED: "пользователь удалено",
    REVIEW_DELETED: "отзыв удален",
    INQUIRY_DELETED: "запрос удален",
    FAILED_TO_DELETE_ORDER: "не удалось удалить заказ",
    FAILED_TO_DELETE_SERVICE: "не удалось удалить услугу",
    FAILED_TO_DELETE_CATEGORY: "не удалось удалить категорию",
    FAILED_TO_DELETE_USER: "не удалось удалить пользователя",
    FAILED_TO_DELETE_REVIEW: "не удалось удалить отзыв",
    FAILED_TO_DELETE_INQUIRY: "не удалось удалить запрос",
    ORDER_NOT_FOUND: "заказ не найден",
    SERVICE_NOT_FOUND: "услуга не найдена",
    CATEGORY_NOT_FOUND: "категория не найдена",
    USER_NOT_FOUND: "пользователь не найден",
    REVIEW_NOT_FOUND: "отзыв не найден",
    INQUIRY_NOT_FOUND: "запрос не найден",
    NOTIFICATION_NOT_FOUND: "оповещение не найдено",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_ORDER: "Вы уверены, что хотите удалить заказ?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_SERVICE: "Вы уверены, что хотите удалить услугу?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_CATEGORY: "Вы уверены, что хотите удалить категорию?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_USER: "Вы уверены, что хотите удалить пользователя?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_REVIEW: "Вы уверены, что хотите удалить отзыв?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_THE_INQUIRY: "Вы уверены, что хотите удалить запрос?",
    ORDER_EDITING: "редактирование заказа",
    SERVICE_EDITING: "редактирование услуги",
    CATEGORY_EDITING: "редактирование категории",
    USER_EDITING: "редактирование пользователя",
    REVIEW_EDITING: "редактирование отзыва",
    INQUIRY_EDITING: "редактирование запроса",
    EDITING_ORDERED_SERVICES: "редактирование заказанных услуг",
    FAILED_TO_PRINT_ORDER: "не удалось распечатать заказ",
    FAILED_TO_SEND_EMAIL: "не удалось отправить электронное письмо",
    FAILED_TO_SIGN_OUT: "не удалось выйти",
    CONTACT: "контакт",
    [tk(Tk.CONTACT, { plural: "one" })]: "контакт",
    ...pluralForSlavic(Tk.CONTACT, "контакты"),
    [tk(Tk.CONTACT, { context: "infinitive" })]: "связаться",
    YOU_HAVE_NO_NOTIFICATIONS: "у вас нет уведомлений",
    NO_REVIEWS_YET: "пока нет отзывов",
    WRITE_A_REVIEW: "написать отзыв",
    WRITING_A_REVIEW: "написание отзыва",
    ORDER_ID: "ИД заказа",
    PAGE_NOT_FOUND: "страница не найдена",
    "IT_LOOKS_LIKE_THE_PAGE_...":
      "Похоже, страница, которую вы ищете, переместилась. Но не волнуйтесь, мы поможем вам вернуться!",
    HOME: "главная",
    RETURN_TO_THE_MAIN_PAGE: "вернуться на главную страницу",
    CALCULATE: "рассчитать",
    CALCULATE_THE_COST_OF_MOVING: "рассчитать стоимость переезда",
    GO_TO: "перейти",
    PERSONAL_DATA_UPDATED: "персональные данные обновлены",
    FAILED_TO_UPDATE_PERSONAL_DATA: "не удалось обновить персональные данные",
    ROLE_DATA_UPDATED: "данные о ролях обновлены",
    FAILED_TO_UPDATE_ROLE_DATA: "не удалось обновить данные роли",
    PAID: "оплаченный",
    UNPAID: "неоплаченный",
    ONLY_IMAGES_IN_JPG_PNG_SVG_FORMATS_ARE_ACCEPTED:
      "принимаются только изображения в форматах {{formats}}",
    FAILED_TO_SAVE_IMAGE: "не удалось сохранить изображение",
    FAILED_TO_DELETE_PREVIOUS_IMAGE: "не удалось удалить предыдущее изображение",
    ARE_YOU_SURE_YOU_WANT_TO_CLEAR_FORM_DATA: "Вы уверены, что хотите очистить данные формы?",
    MAX: "макс",
    REVIEW_DETAILS: "подробности отзыва",
    ORDER_NUMBER: "номер заказа",
    "NO.": "№",
    OPEN_NAVIGATION_MENU: "открыть навигационное меню",
    CLOSE_NAVIGATION_MENU: "закрыть меню навигации",
    PLEASE_PROVIDE_THIS_INFORMATION_ONLY_IF_YOU_WOULD_LIKE_US_TO_CONTACT_YOU:
      "Пожалуйста, предоставьте эту информацию только в том случае, если вы хотите, чтобы мы связались с вами.",
    THIS_INFORMATION_WILL_NOT_BE_AVAILABLE_PUBLICLY: "Эта информация не будет доступна публично.",
    OPTIONAL: "необязательный",
    PLEASE_PROVIDE_AT_LEAST_ONE_CONTACT_INFORMATION:
      "пожалуйста, предоставьте хотя бы одну контактную информацию",
    ORDER_DETAILS: "детали заказа",
    ORDER_SUMMARY: "сводка заказа",
    CUSTOMER_SUPPORT: "клиентская поддержка",
    APPROVED: "одобрено",
    REJECTED: "отклонено",
    APPROVE: "утвердить",
    DISAPPROVE: "отклонить",
    REVIEW_SUCCESSFULLY_APPROVED: "отзыв успешно одобрен",
    FAILED_TO_APPROVE_REVIEW: "не удалось одобрить отзыв",
    MY_ORDERS: "мои заказы",
    DELETE_ALL: "удалить все",
    "THIS_IS_SIMPLY_A_LIST_OF_ORDERS...":
      "Это просто список заказов, сохраненных на вашем устройстве, поэтому вы можете в любой момент просмотреть подробную информацию о каждом из них.",
    "DELETING_A_SPECIFIC_OR_ALL_ORDERS...":
      "Удаление определенного или всех заказов удаляет только эти данные с вашего устройства и не влияет на данные, хранящиеся в базе данных.",
    "IF_YOU_NEED_TO_CHANGE_ANY_INFORMATION...":
      "Если вам необходимо изменить какую-либо информацию о вашем заказе или отменить его, пожалуйста, свяжитесь с нами.",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ALL_ORDERS: "Вы уверены, что хотите удалить все заказы?",
    ARE_YOU_SURE_YOU_WANT_TO_DELETE_ORDER_N: "Вы уверены, что хотите удалить заказ №{{number}}?",
    YOU_HAVEN_T_CREATED_ANY_ORDERS_YET: "вы еще не создали ни одного заказа",
    "YOUR_REVIEW_WILL_BE_PUBLISHED_AFTER...":
      "ваш отзыв будет опубликован после проверки администратором",
    CHANGE_PASSWORD: "изменить пароль",
    PASSWORD_CHANGE: "смена пароля",
    CURRENT_PASSWORD: "текущий пароль",
    NEW_PASSWORD: "новый пароль",
    REPEAT_NEW_PASSWORD: "повторите новый пароль",
    PASSWORDS_DO_NOT_MATCH: "пароли не совпадают",
    PASSWORD_CHANGED: "пароль изменен",
    FAILED_TO_CHANGE_PASSWORD: "не удалось сменить пароль",
    CURRENT_PASSWORD_IS_INCORRECT: "текущий пароль неверный",
    INSUFFICIENT_RIGHTS_TO_PERFORM_THIS_ACTION: "недостаточно прав для выполнения этого действия",
    CASH_PAYMENT_IS_POSSIBLE: "возможна оплата наличными",
    WE_HAVE_SPECIAL_OFFERS_FOR_SENIORS: "у нас есть специальные предложения для пожилых людей",
    WE_PROVIDE_A_10_DISCOUNT_FOR_STUDENTS: "мы предоставляем 10% скидку для студентов",
    ABOUT_US: "о нас",
    PASSWORD_RESET: "сброс пароля",
    "ENTER_THE_EMAIL_ADDRESS_ASSOCIATED_WITH_YOUR_ACCOUNT...":
      "введите адрес электронной почты, связанный с вашей учетной записью, и мы отправим вам письмо с новым паролем",
    RESET_PASSWORD: "сбросить пароль",
    PASSWORD_RESET_SUCCESSFUL: "сброс пароля успешен",
    AN_EMAIL_WITH_A_NEW_PASSWORD_HAS_BEEN_SENT_TO_YOUR_ADDRESS:
      "на ваш адрес было отправлено письмо с новым паролем",
    FAILED_TO_SEND_PASSWORD_RESET_REQUEST: "не удалось отправить запрос на сброс пароля",
    AN_ACCOUNT_WITH_THE_SPECIFIED_EMAIL_ADDRESS_WAS_NOT_FOUND:
      "учетная запись с указанным адресом электронной почты не найдена",
    ABOUT_US_CHAPTER_1_TITLE: "ВАШ ДОМ - НАША РАБОТА",
    ABOUT_US_CHAPTER_1_PARAGRAPH:
      "Мы гарантируем, что ваш переезд пройдет гладко. Независимо от того, переезжаете ли вы в новый город, переезжаете в свой первый дом, или вам нужно больше места с семьей – <strong>мы сделаем ваш переезд легким и, прежде всего, бесстрессовым</strong>.",
    ABOUT_US_CHAPTER_2_TITLE: "ВАША КОМПАНИЯ – НАША РАБОТА",
    ABOUT_US_CHAPTER_2_PARAGRAPH_1:
      "<strong>Переезд с компанией может оказаться большим вызовом</strong>.",
    ABOUT_US_CHAPTER_2_PARAGRAPH_2:
      "Вот почему полезно иметь рядом компетентного и опытного партнера. Мы специализируемся на эффективном и минимальном простое в осуществлении корпоративных переездов. Вы сосредоточьтесь на своем основном бизнесе, а мы позаботимся об остальных.",
    ABOUT_US_CHAPTER_3_TITLE: "УТИЛИЗАЦИЯ",
    ABOUT_US_CHAPTER_3_PARAGRAPH_1: "<strong>Освободите пространство без стресса</strong>.",
    ABOUT_US_CHAPTER_3_PARAGRAPH_2:
      "Старая мебель, электроприборы или сломанные вещи? Что бы вам ни нужно было утилизировать, мы позаботимся об этом <strong>экологически и профессионально</strong>. То ли после переезда, уборки дома, то ли из-за необходимости дополнительного пространства – мы позаботимся о надлежащей утилизации всего.",
    ABOUT_US_CHAPTER_4_TITLE: "О HEGI UMZÜGE",
    ABOUT_US_CHAPTER_4_PARAGRAPH_1:
      "Мы молодая, энергичная команда, которая стремится стать надежным партнером в сфере переездов. Хотя мы были основаны недавно, у нас есть богатый опыт работы с ведущими компаниями отрасли. Мы знаем, как организовать переезд таким образом, чтобы он был быстрым, безопасным и бесстрессовым для наших клиентов.",
    ABOUT_US_CHAPTER_4_PARAGRAPH_2:
      "Учредив собственную компанию, мы объединили передовой опыт и идеи, чтобы вывести наши услуги на новый уровень. Наша цель – не просто перевезти вещи, а дать людям уверенность и безопасность в решающий этап их жизни. Мы растем, учимся и совершенствуемся каждый день — во благо тех, кто доверяет нам свой переезд.",
    SHOW_MY_ORDERS: "показать мои заказы",
    HIDE_MY_ORDERS: "скрыть мои заказы",
    QR_CODE_TO_GO_TO_THIS_SITE: "QR-код для перехода на этот сайт",
    ALL_SERVICES_BELONGING_TO_THIS_CATEGORY_WILL_BE_DELETED:
      "все услуги, относящиеся к этой категории, будут удалены",
    THE_ORDER_CANNOT_BE_UPDATED_BECAUSE_IT_HAS_ALREADY_BEEN_FULFILLED:
      "заказ не может быть обновлен, так как он уже выполнен",
    CHANGE_OF_STATUS: "изменение статуса",
    THE_ORDER_STATUS_IS_COMPLETED_ARE_YOU_SURE_YOU_WANT_TO_CHANGE_IT_TO_NEW:
      "Статус заказа — «{{current}}». Вы уверены, что хотите изменить его на «{{new}}»?",
    CHANGE_PAYMENT_STATUS: "изменить статус оплаты",
    PAYMENT_STATUS_CHANGE: "изменение статуса оплаты",
    PAYMENT_STATUS_CHANGED: "статус оплаты изменился",
    FAILED_TO_CHANGE_PAYMENT_STATUS: "не удалось изменить статус оплаты",
    MOST_LIKELY_IT_WAS_DELETED: "скорее всего, его удалили",
    SETTINGS: "настройки",
    CLOSE: "закрыть",
    CONSENT_MODAL_TITLE: "мы используем файлы cookie",
    CONSENT_MODAL_DESCRIPTION:
      "Мы используем файлы cookie для работы нашего веб-сайта, а также для показа и анализа рекламы через Google Ads. Основные файлы cookie используются всегда. Все остальные файлы cookie используются только с вашего согласия. Вы можете принять все файлы cookie, отклонить дополнительные или изменить свои настройки.",
    CONSENT_MODAL_ACCEPT_ALL: "принять все",
    CONSENT_MODAL_ACCEPT_NECESSARY: "принимать только необходимые",
    CONSENT_PREFERENCES_MODAL_TITLE: "настройки файлов cookie",
    CONSENT_PREFERENCES_MODAL_SAVE_PREFERENCES: "принять",
    CONSENT_PREFERENCES_MODAL_SERVICE: "сервис(ы)",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_TITLE: "необходимые",
    CONSENT_PREFERENCES_MODAL_SECTION_NECESSARY_DESCRIPTION:
      "Эти файлы cookie необходимы для корректной работы сайта, например для аутентификации пользователей.",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_TITLE: "аналитика",
    CONSENT_PREFERENCES_MODAL_SECTION_ANALYTICS_DESCRIPTION:
      "Файлы cookie, используемые для аналитики, помогают собирать данные, которые позволяют сервисам понимать, как пользователи взаимодействуют с конкретным сервисом.",
    CONSENT_PREFERENCES_MODAL_SERVICE_ANALYTICS_STORAGE:
      "Разрешает хранение данных (например, файлов cookie), связанных с аналитикой, таких как продолжительность вашего посещения.",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_TITLE: "реклама",
    CONSENT_PREFERENCES_MODAL_SECTION_ADVERTISING_DESCRIPTION:
      "Google использует файлы cookie в рекламных целях, включая показ и доставку рекламы, персонализацию рекламы, ограничение количества показов рекламы, отключение рекламы, которую вы решили не видеть, а также измерение эффективности рекламы.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_STORAGE:
      "Разрешает хранение данных (например, файлов cookie), связанных с рекламой.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_USER_DATA:
      "Разрешает отправку пользовательских данных, связанных с рекламой, в Google.",
    CONSENT_PREFERENCES_MODAL_SERVICE_AD_PERSONALIZATION:
      "Разрешает использование данных для персонализированной рекламы.",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_TITLE: "функциональность",
    CONSENT_PREFERENCES_MODAL_SECTION_FUNCTIONALITY_DESCRIPTION:
      "Функциональные файлы cookie позволяют пользователям взаимодействовать с сервисом или сайтом и получать доступ к функциям, которые являются важными для работы данного сервиса.",
    CONSENT_PREFERENCES_MODAL_SERVICE_FUNCTIONALITY_STORAGE:
      "Разрешает хранение данных, поддерживающих функциональность сайта или приложения, например языковых настроек.",
    CONSENT_PREFERENCES_MODAL_SERVICE_PERSONALIZATION_STORAGE:
      "Разрешает хранение данных, связанных с персонализацией, например рекомендаций.",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_TITLE: "безопасность",
    CONSENT_PREFERENCES_MODAL_SECTION_SECURITY_DESCRIPTION:
      "Файлы cookie, используемые в целях безопасности, например для аутентификации пользователей, предотвращения мошенничества и защиты пользователей при взаимодействии с сервисом.",
    CONSENT_PREFERENCES_MODAL_SERVICE_SECURITY_STORAGE:
      "Разрешает хранение данных, связанных с безопасностью, таких как данные для аутентификации, предотвращения мошенничества и других функций защиты пользователей.",
    THE_PAGE_LANGUAGE_HAS_CHANGED_BUT_THE_CONTENTS:
      "Язык страницы изменился, но содержимое диалогового окна с файлами cookie обновится только после перезагрузки страницы.",
    IF_YOU_ARE_NOT_INTERESTED_IN_THE_CONTENTS:
      "Если вас не интересует содержимое диалогового окна, связанного с файлами cookie, вы можете проигнорировать это сообщение.",
    RELOAD_PAGE: "перезагрузить страницу",
    CONSENT_SUMMARY_TITLE: "статус согласия на обработку данных",
    CONSENT_SUMMARY_DESCRIPTION:
      "Краткий обзор текущего статуса вашего согласия. Подробная информация доступна в настройках.",
    CONSENT_ID: "ID согласия",
    LAST_MODIFIED: "последнее изменение",
    CONSENT_SUMMARY_ALLOWED: "разрешено",
    CONSENT_SUMMARY_PARTIALLY_ALLOWED: "частично разрешено",
    CONSENT_SUMMARY_BLOCKED: "заблокировано",
  } satisfies Record<Tk, string>,
} satisfies ResourceLanguage;

export { RESOURCES };
